import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cm-uti',
  templateUrl: './uti.component.html',
  styleUrls: ['./uti.component.css']
})
export class UtiComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
